import {CommonModule, NgOptimizedImage} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {YouTubePlayer} from '@angular/youtube-player';
import {NbSecurityModule} from '@nebular/security';
import {NbAccordionModule, NbAlertModule, NbButtonModule, NbCardModule, NbCheckboxModule, NbIconModule, NbInputModule, NbLayoutModule, NbSpinnerModule, NbTabsetModule, NbTooltipModule} from '@nebular/theme';
import {TuiHintDirective} from '@taiga-ui/core';
import {formatPriceNumber, GridGearComponent, ImagePreviewComponent, SafeHtmlPipe, SharedModule, TrueFalseToYesNoPipe} from 'compob2b-libs';
import {TableModule} from 'compob2b-table';
import {NgxPaginationModule} from 'ngx-pagination';
import {BreadcrumbsComponent} from '../../../../../compob2b-admin/src/app/admin-shared/breadcrumbs/breadcrumbs.component';
import {BaseModule} from '../../../../../compob2b-table/lib/components/base/base.module';
import {CartModule} from '../cart/cart.module';
import {PhotoSliderComponent} from '../photo-slider/photo-slider.component';
import {AddToSpecificationPopupComponent} from './add-to-specification-popup/add-to-specification-popup.component';
import {AddToRequestedProductsPopupComponent} from './add-to-requested-products-popup/add-to-requested-products-popup.component';
import {CodeIconsComponent} from './code-icons/code-icons.component';
import {ModalProductComponent} from './modal-product/modal-product.component';
import {ProductAnalogsComponent} from './product-analogs/product-analogs.component';
import {SearchCodeHighlightComponent} from '../search-code-highlight/search-code-highlight.component';
import {ProductListComponent} from './product-list/product-list.component';
import {ProductMarkersComponent} from './product-markers/product-markers.component';
import {ProductRoutingModule} from './product-routing.module';
import {ProductViewComponent} from './product-view/product-view.component';
import {ProductPriceComponent} from './product-list/product-price/product-price.component'
import {ProductAvailabilityComponent} from './product-list/product-availability/product-availability.component'
import {ProductWmsComponent} from './product-list/product-wms/product-wms.component'
import {AddToCartComponent} from "../cart/add-to-cart/add-to-cart.component";

@NgModule({
  declarations: [
    ProductAnalogsComponent, ProductViewComponent, ProductListComponent, PhotoSliderComponent,
    ModalProductComponent, AddToSpecificationPopupComponent, AddToRequestedProductsPopupComponent
  ],
  exports: [
    ProductListComponent, ModalProductComponent, ProductViewComponent, PhotoSliderComponent
  ],
  imports: [
    SearchCodeHighlightComponent,
    NbIconModule,
    CommonModule,
    ProductRoutingModule,
    SharedModule,
    NbTabsetModule,
    NbSpinnerModule,
    CartModule,
    NbCardModule,
    TableModule,
    NbTooltipModule,
    NbButtonModule,
    NbInputModule,
    NbLayoutModule,
    NbSecurityModule,
    NbAlertModule,
    NbCheckboxModule,
    FormsModule,
    NbAccordionModule,
    GridGearComponent,
    YouTubePlayer,
    ImagePreviewComponent,
    NgxPaginationModule,
    BaseModule,
    TuiHintDirective,
    ProductMarkersComponent,
    BreadcrumbsComponent,
    CodeIconsComponent,
    NgOptimizedImage,
    formatPriceNumber,
    ProductPriceComponent,
    ProductAvailabilityComponent,
    ProductWmsComponent,
    TrueFalseToYesNoPipe,
    SafeHtmlPipe,
    AddToCartComponent
  ]
})
export class ProductModule {
}
